(function ($) {
    function addClassIfNotEmpty(input) {
        if (input.val().trim() === '') {
            input.removeClass('filled');
        } else {
            input.addClass('filled');
        }
    }

    function print_placeholders(){
        $('.gform_wrapper').each(function (){
            let form_wrapper = $(this);
            let inputs = form_wrapper.find('.gform-grid-col > input[type="text"], ' +
                '.gform-grid-col > input[type="tel"], ' +
                '.gform-grid-col > input[type="email"], ' +
                '.gform-grid-col > textarea, ' +
                '.ginput_container > input[type="text"], ' +
                '.ginput_container > input[type="tel"], ' +
                '.ginput_container > input[type="email"], ' +
                '.ginput_container > textarea'
            );

            inputs.each(function (){
                let input = $(this),
                    gfield = input.parents('.gfield'),
                    label_html = gfield.find('.gfield_label').html();

                if(input.parent().is('.gform-grid-col')){
                    label_html = input.siblings('.gform-field-label').html();

                    if(input.attr('aria-required') === 'true'){
                        label_html += '<span class="gfield_required"><span class="gfield_required gfield_required_asterisk">*</span></span>';
                    }
                }

                if(input.parents().is('.additional-number')){
                    if(input.val().trim() === ''){
                        input.parents('.additional-number').prepend('<span class="additional-input-btn">+ Add Phone Number</span>');
                    } else {
                        input.addClass('filled').parents('.ginput_container').show(0);
                    }
                }

                // add class if input not empty
                input.on('input keyup', function() {
                    addClassIfNotEmpty(input);
                });

                addClassIfNotEmpty(input);

                input.after('<span class="label-placeholder">'+ label_html +'</span>');
            });

            $('body').on('click', '.additional-input-btn', function (){
                $(this).hide(0);
                $(this).siblings('.ginput_container').show(0);
            });
        });
    }

    print_placeholders();

    observeContentChange('.gravity-theme', print_placeholders);
}(jQuery));
